import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  TextField,
  Button,
  Typography,
  styled,
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  useFetchOrgDataQuery,
  useUpdateOrganizationMutation,
} from "../../services/profileService";

const EditOrg = () => {
  const { id: organization_id } = useParams();
  
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // Fetch organization details
  const {
    data: organization,
    isLoading,
    error,
  } = useFetchOrgDataQuery(organization_id);

  // Mutation to update organization
  const [updateOrganization] = useUpdateOrganizationMutation();

  // Snackbar state to show toast on success
  // const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showRegistrationDialog, setShowRegistrationDialog] = useState(false);

  useEffect(() => {
    if (organization) {
      setValue("organization_name", organization?.data?.organization_name);
      setValue("owner_name", organization?.data?.owner_name);
      setValue("owner_email", organization?.data?.owner_email);
    }
  }, [organization, setValue]);

  const onSubmit = async (data) => {
    try {
      await updateOrganization({
        organizationID: organization_id,
        data,
      }).unwrap();
      setShowRegistrationDialog(true);
      
    } catch (err) {
      console.error("Error updating organization:", err);
    }
  };

  // const handleCloseSnackbar = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setOpenSnackbar(false);
  // };

  if (isLoading) return <Typography>Loading...</Typography>;
  if (error)
    return (
      <Typography color="error">Error loading organization details.</Typography>
    );
    const closeRegistrationDialog = () => {
        setShowRegistrationDialog(false);
        navigate("/view-org");
      };

  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap>
            <Col12Wrap sx={{ textAlign: "center", marginBottom: "20px" }}>
              <Typography
                sx={{
                  fontSize: "25px",
                  textAlign: "center",
                  fontWeight: "500",
                  margin: "0 10px",
                  color: "#2C2C2E",
                }}
              >
                Edit Organization
              </Typography>
            </Col12Wrap>
            <Col12Wrap>
              <form onSubmit={handleSubmit(onSubmit)}>
                <FormMiddleBoxWrap>
                  <RowWrap>
                    <Col6Wrap>
                      <FormGroupWrap>
                        <FormLabelWrap>Name</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          {...register("organization_name", {
                            required: "Required",
                          })}
                          placeholder="Organization Name"
                          error={!!errors.organization_name}
                        />
                        {errors.organization_name && (
                          <ErrorText>
                            {errors.organization_name.message}
                          </ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col6Wrap>
                    <Col6Wrap>
                      <FormGroupWrap>
                        <FormLabelWrap>Owner</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          {...register("owner_name", { required: "Required" })}
                          placeholder="Owner Name"
                          error={!!errors.owner_name}
                        />
                        {errors.owner_name && (
                          <ErrorText>{errors.owner_name.message}</ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col6Wrap>
                    <Col12Wrap>
                      <FormGroupWrap>
                        <FormLabelWrap>Email</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          {...register("owner_email", {
                            required: "Required",
                            pattern: {
                              value: /^\S+@\S+$/,
                              message: "Invalid email",
                            },
                          })}
                          placeholder="Owner Email"
                          error={!!errors.owner_email}
                        />
                        {errors.owner_email && (
                          <ErrorText>{errors.owner_email.message}</ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col12Wrap>
                  </RowWrap>
                </FormMiddleBoxWrap>
                <FormBtnBoxWrap>
                  <RowWrap>
                    <Col12Wrap sx={{ textAlign: "center" }}>
                      <CustomBtn variant="outlined" type="submit">
                        Save
                      </CustomBtn>
                      <CustomBtn
                        variant="contained"
                        color="secondary"
                        sx={{ marginLeft: "10px" }}
                        onClick={() => navigate("/view-org")}
                      >
                        Back to Admin Portal
                      </CustomBtn>
                    </Col12Wrap>
                  </RowWrap>
                </FormBtnBoxWrap>
              </form>
            </Col12Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
      <Dialog
      open={showRegistrationDialog}
      onClose={closeRegistrationDialog}
      fullWidth
      maxWidth="sm"
      sx={{
        textAlign: "center",
        "& .MuiDialog-paper": {
          padding: "30px",
        },
      }}
    >
      <DialogTitle>Organization details has been modified</DialogTitle>
      <DialogActions sx={{ justifyContent: "center" }}>
        <CustomBtn onClick={closeRegistrationDialog}>OK</CustomBtn>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default EditOrg;

const SectionWrap = styled(Box)(() => ({
  padding: "30px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 15px",
  maxWidth: "250px",
  boxShadow: "none !important",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "50%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 767px)": {
    width: "100%",
  },
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "30px",
  position: "relative",
}));
const CustomTextField = styled(TextField)(() => ({
  border: "1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const ErrorText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#ff0000",
  marginTop: "5px",
}));
const FormLabelWrap = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#2C2C2E",
  marginBottom: "5px",
}));
